// Gestione globale dei click
document.addEventListener('click', function(event) {
  const productCard = event.target.closest('.product-card');
  if (!productCard) return;

  // Toggle overlay
  if (event.target.closest('.product-card__quick-add-toggle')) {
    event.preventDefault();
    toggleOverlay(productCard);
    return;
  }

  // Selezione taglia
  if (event.target.closest('.product-card__size-btn')) {
    event.preventDefault();
    const sizeBtn = event.target.closest('.product-card__size-btn');
    selectSize(productCard, sizeBtn);
    return;
  }

  // Aggiungi al carrello
  if (event.target.closest('.product-card__add-to-cart-btn')) {
    event.preventDefault();
    addToCart(productCard);
    return;
  }

  // Wishlist
  if (event.target.closest('.product-card__wishlist-btn')) {
    event.preventDefault();
    toggleWishlist(productCard);
    return;
  }

  // Image link click - allow default behavior (navigation to product page)
  if (event.target.closest('.product-card__image-link')) {
    // Don't prevent default - let the link work normally
    return;
  }
});

// Toggle overlay della specifica card
function toggleOverlay(card) {
  const toggle = card.querySelector('.product-card__quick-add-toggle');
  const overlay = card.querySelector('.product-card__size-overlay');
  
  if (!toggle || !overlay) return;
  
  const isOpen = card.classList.contains('show-sizes');
  
  if (isOpen) {
    // Chiudi
    card.classList.remove('show-sizes');
    toggle.classList.remove('active');
    overlay.classList.remove('active');
    resetSelections(card);
  } else {
    // Chiudi altri overlay aperti
    document.querySelectorAll('.product-card.show-sizes').forEach(otherCard => {
      if (otherCard !== card) {
        toggleOverlay(otherCard);
      }
    });
    
    // Apri questo
    card.classList.add('show-sizes');
    toggle.classList.add('active');
    overlay.classList.add('active');
  }
}

// Selezione taglia
function selectSize(card, sizeBtn) {
  const variantId = sizeBtn.dataset.variantId;
  const variantInput = card.querySelector('.product-card__variant-input');
  const addToCartBtn = card.querySelector('.product-card__add-to-cart-btn');
  
  // Rimuovi selezione precedente
  card.querySelectorAll('.product-card__size-btn').forEach(btn => {
    btn.classList.remove('selected');
  });
  
  // Seleziona nuovo
  sizeBtn.classList.add('selected');
  
  // Aggiorna form
  if (variantInput) {
    variantInput.value = variantId;
  }
  
  // Abilita bottone
  if (addToCartBtn) {
    addToCartBtn.disabled = false;
  }
  
  // Aggiorna stato wishlist per questa variante specifica
  if (window.wishlist) {
    window.wishlist.updateWishlistButtons();
  }
}

// Aggiungi al carrello - USA LA STESSA LOGICA DI product-form.js
async function addToCart(card) {
  const variantInput = card.querySelector('.product-card__variant-input');
  const addToCartBtn = card.querySelector('.product-card__add-to-cart-btn');

  if (!variantInput || !variantInput.value || addToCartBtn.disabled) return;

  // Loading state
  addToCartBtn.classList.add('loading');
  addToCartBtn.disabled = true;

  // Check if we're on cart page
  const isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';

  // Ottieni riferimento al cart drawer o cart notification (come in product-form.js:11)
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  try {
    // Prepara FormData con le sections da aggiornare (come in product-form.js:34-43)
    const formData = new FormData();
    formData.append('id', variantInput.value);
    formData.append('quantity', '1');

    if (cart && !isCartPage) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    // Fetch config (come in product-form.js:30-32)
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    const responseData = await response.json();

    if (responseData.status) {
      // Errore (come in product-form.js:48-63)
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-card',
        productVariantId: variantInput.value,
        errors: responseData.errors || responseData.description,
        message: responseData.message,
      });
      showError(responseData.description || 'Errore aggiunta al carrello');
      return;
    }

    // Successo - chiudi overlay
    toggleOverlay(card);

    // Pubblica evento cartUpdate SEMPRE (per aggiornare cart-page.js se siamo su cart)
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-card',
      productVariantId: variantInput.value,
      cartData: responseData,
    });

    // Renderizza il cart drawer/notification SOLO se NON siamo sulla pagina cart
    if (!isCartPage) {
      if (!cart) {
        // Se non c'è cart drawer/notification, redirect al carrello
        window.location = window.routes.cart_url;
        return;
      }
      // Questo aggiorna automaticamente il contatore E apre il drawer
      cart.renderContents(responseData);
    }

  } catch (error) {
    console.error('Errore:', error);
    showError('Errore aggiunta al carrello');
  } finally {
    // Remove loading state
    addToCartBtn.classList.remove('loading');
    addToCartBtn.disabled = false;
  }
}

// Toggle wishlist
function toggleWishlist(card) {
  const wishlistBtn = card.querySelector('.product-card__wishlist-btn');
  if (!wishlistBtn) return;
  
  wishlistBtn.classList.toggle('active');
  
  // Animazione
  wishlistBtn.classList.add('animate-heartbeat');
  setTimeout(() => {
    wishlistBtn.classList.remove('animate-heartbeat');
  }, 600);
  
  // Non gestisce l'aggiunta - lascia che wishlist.js lo faccia
  // ma passiamo i dati della variante
}

// Reset selezioni
function resetSelections(card) {
  const variantInput = card.querySelector('.product-card__variant-input');
  const addToCartBtn = card.querySelector('.product-card__add-to-cart-btn');
  
  // Reset bottoni taglie
  card.querySelectorAll('.product-card__size-btn').forEach(btn => {
    btn.classList.remove('selected');
  });
  
  // Reset form
  if (variantInput) {
    variantInput.value = '';
  }
  
  // Disabilita bottone se ci sono multiple taglie
  if (addToCartBtn && card.querySelectorAll('.product-card__size-btn').length > 0) {
    addToCartBtn.disabled = true;
  }
}

// Mostra errore
function showError(message) {
  const toast = document.createElement('div');
  toast.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #e74c3c;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 9999;
  `;
  toast.textContent = message;
  document.body.appendChild(toast);
  
  setTimeout(() => {
    toast.remove();
  }, 3000);
}

// CSS per animazioni
const style = document.createElement('style');
style.textContent = `
  .animate-heartbeat { animation: heartbeat 0.6s ease; }
  .cart-success { animation: pulse 1.5s ease; }
  
  @keyframes heartbeat {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
  }
  
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.7; }
  }
`;
document.head.appendChild(style);
